import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, Instagram, MapPin, Phone } from 'lucide-react';
import { FaTiktok } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import profLogo from '../assets/prof-logo.png';

const footerCopy = {
  en: { company: 'Al Professor', line: 'Independent vehicle inspection for clearer decisions.', explore: 'Explore', services: 'Services', book: 'Book inspection', blog: 'Insights', contact: 'Contact', location: 'Musaffah, Abu Dhabi, UAE', legal: 'Legal', privacy: 'Privacy policy', cookies: 'Cookies policy', rights: 'All rights reserved.', top: 'Back to top' },
  ar: { company: 'البروفيسور', line: 'فحص مركبات مستقل لقرارات أكثر وضوحاً.', explore: 'استكشف', services: 'الخدمات', book: 'احجز فحصاً', blog: 'المقالات', contact: 'تواصل معنا', location: 'مصفح، أبوظبي، الإمارات', legal: 'قانوني', privacy: 'سياسة الخصوصية', cookies: 'سياسة ملفات الارتباط', rights: 'جميع الحقوق محفوظة.', top: 'إلى الأعلى' },
};

const PublicFooter = () => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  const lang = i18n.language === 'en' ? 'en' : 'ar';
  const c = footerCopy[lang];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <footer className="site-footer" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <div className="site-container footer-main">
        <div className="footer-brand">
          <Link to={`/${lang}/`} className="footer-logo"><img src={profLogo} alt="Al Professor" /></Link>
          <p>{c.line}</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/cars.inspection" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={18} /></a>
            <a href="https://www.tiktok.com/@professorcarcenter" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><FaTiktok size={17} /></a>
          </div>
        </div>
        <div className="footer-column">
          <h3>{c.explore}</h3>
          <Link to={`/${lang}/#services-section`}>{c.services}</Link>
          <Link to={`/${lang}/book`}>{c.book}</Link>
          <Link to={`/${lang}/blog`}>{c.blog}</Link>
        </div>
        <div className="footer-column footer-contact">
          <h3>{c.contact}</h3>
          <a href="tel:+971561868236"><Phone size={15} /><bdi dir="ltr" className="phone-number">+971 56 186 8236</bdi></a>
          <a href="https://maps.app.goo.gl/pCJaz6oGmEgim6gk6" target="_blank" rel="noopener noreferrer"><MapPin size={15} />{c.location}</a>
        </div>
        <div className="footer-column">
          <h3>{c.legal}</h3>
          <Link to={`/${lang}/privacy-policy`}>{c.privacy}</Link>
          <Link to={`/${lang}/cookies-policy`}>{c.cookies}</Link>
        </div>
      </div>
      <div className="site-container footer-bottom">
        <p>© {new Date().getFullYear()} {c.company}. {c.rights}</p>
        <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>{c.top}<ArrowUpRight size={15} /></button>
      </div>
    </footer>
  );
};

export default PublicFooter;
